module.exports = __webpack_public_path__ + "static/og-966f7fd3714e6019411feb97496091fb.png";